import { createAsyncThunk } from "@reduxjs/toolkit";

import { axiosInstance as axios } from "../../../../api/axiosInstance";
import { showSnackbar } from "../../../reducers/snackbar/snackbarSlice";

export const regenerateRegistrationLink = createAsyncThunk(
  "regenerateRegistrationLink",
  async(userId: string | number | undefined, thunkAPI) => {
    const { dispatch, rejectWithValue } = thunkAPI;

    return axios.get(`/api/v1/users/${userId}/regenerate-registration-link`)
      .then((resp) => {
        return resp.data;
      })
      .catch(() => {
        const errorMessage = "There was an error getting the registration link";

        dispatch(showSnackbar({
          message: errorMessage,
          variant: "error"
        }));

        return rejectWithValue(errorMessage);
      });
  }
);
